// src/pages/contact.js
import React from 'react';
import ContactHero from '../components/contact/ContactHero';
import ContactForm from '../components/contact/ContactForm';
import { FaEnvelope, FaPhone, FaInstagram, FaWhatsapp } from 'react-icons/fa';

const ContactPage = () => {
  const email = 'info@example.com'; // Replace with your actual email
  const phone = '+91 1234567890'; // Replace with your actual phone number
  const instagramLink = 'https://instagram.com/your_handle'; // Replace with your Instagram link
  const whatsappLink = 'https://wa.me/911234567890'; // Replace with your WhatsApp link

  return (
    <div className="bg-gray-100">
      <ContactHero />
      <div className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Contact Information */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">Get in Touch</h3>
            <ul className="space-y-4">
              <li>
                <div className="flex items-center">
                  <FaEnvelope className="text-purple-500 mr-3" size={20} />
                  <a href={`mailto:${email}`} className="text-gray-800 hover:text-purple-600">
                    {email}
                  </a>
                </div>
              </li>
              <li>
                <div className="flex items-center">
                  <FaPhone className="text-purple-500 mr-3" size={20} />
                  <a href={`tel:${phone}`} className="text-gray-800 hover:text-purple-600">
                    {phone}
                  </a>
                </div>
              </li>
              <li>
                <div className="flex items-center">
                  <FaInstagram className="text-purple-500 mr-3" size={20} />
                  <a href={instagramLink} target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-purple-600">
                    Instagram DM
                  </a>
                </div>
              </li>
              <li>
                <div className="flex items-center">
                  <FaWhatsapp className="text-purple-500 mr-3" size={20} />
                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="text-gray-800 hover:text-purple-600">
                    WhatsApp
                  </a>
                </div>
              </li>
              {/* You can add more contact methods here */}
            </ul>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-lg shadow-md p-6">
            <h3 className="text-xl font-semibold text-gray-700 mb-4">Send us a Message</h3>
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;